// removed by extract-text-webpack-plugin
module.exports = {"Question":"_2va1zUTmKBP6nDjcYHBeGh","SmallFont":"_1f9RNKoa-T4n3zzPZwwneZ","SmallPadding":"_2aF4nYDdrDy5b0F1R-tw2N","NoMargin":"_1QrCSq4nM-grH2kJ-Bw9tM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Question/Question.css
// module id = 261
// module chunks = 0